import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

import { log } from "@/utils/log";

export const useNotificationSubscription = (userId: string | undefined) => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  useEffect(() => {
    if (!userId) return;

    log.log('Setting up notification subscription for user:', userId);

    const channel = supabase
      .channel(`notifications-${userId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notifications',
          filter: `user_id=eq.${userId}`
        },
        (payload) => {
          log.log('Notification change detected:', payload);
          
          // Invalidate notifications queries
          queryClient.invalidateQueries({
            queryKey: ['notifications']
          });
          queryClient.invalidateQueries({
            queryKey: ['notifications-unread']
          });

          if (payload.eventType === 'INSERT') {
            toast({
              title: "New notification",
              description: "You have a new notification",
            });
          }
        }
      )
      .subscribe((status) => {
        log.log('Notification subscription status:', status);
      });

    return () => {
      log.log('Cleaning up notification subscription');
      supabase.removeChannel(channel);
    };
  }, [userId, queryClient, toast]);
};